export default __webpack_public_path__ + "static/media/remiderIconPink.488b16be.svg";